import axios from 'axios';

const BASE_URL = `/services/isnaportal/open-api/register-organization`;

const API_ENDPOINTS = {
    searchSro: `${BASE_URL}/search`,
    downloadSro: `${BASE_URL}/export`,
};

const getSro = async (data: any): Promise<any> => {
    const response = await axios.get(API_ENDPOINTS.searchSro, { params: { ...data } });
    return response;
};

const downloadSro = async (data: any): Promise<any> => {
    const response = await axios.get(API_ENDPOINTS.downloadSro, {
        params: { ...data },
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
    });
    return response;
};

export { API_ENDPOINTS, getSro, downloadSro };
